import { default as Users } from './components/Users/UsersContainer';

export default Users;
